import { JourneyTrack } from "../journey-track";
import { TrackTypes } from "../model/track-types";
import { TrackInfo } from "../model/track-info";
import { TrackActionResult } from "../model/track-action-result";
import { ContaIonDataParse } from "../conta-ion/util/conta-ion-data-parse";
import { CacheService } from "../../../comunicator-native/cache/v2/cache.service";
import { MaritalStatusInvestAction } from "./actions/marital-status-action";
import { OriginIncomeInvestAction } from "./actions/origin-income-action";
import { OriginInvestAction } from "./actions/origin-action";
import { BirthCountryInvestAction } from "./actions/birth-country-action";
import { trackDefaultIncomeBasic } from "./util/track-default-income";

export class BasicTrack extends JourneyTrack {
  readonly originalTracks = [
    new TrackInfo("document-type", ["personal-data", "document-type"]),
    new TrackInfo("document-name", ["personal-data", "document-name"]),
    new TrackInfo("document-number", ["personal-data", "document-number"]),
    new TrackInfo("document-issuing", ["personal-data", "document-issuing"]),
    new TrackInfo("expedition-state", ["personal-data", "expedition-state"]),
    new TrackInfo("parentage", ["personal-data", "parentage"]),
    new TrackInfo(
      "birth-country",
      ["personal-data", "birth-country"],
      undefined,
      {
        undefined,
        actionName: ActionList.ActionStateBR,
      }
    ),
    new TrackInfo("birth-state", ["personal-data", "birth-state"]),
    new TrackInfo("birth-city", ["personal-data", "birth-city"]),
    new TrackInfo("nationality", ["personal-data", "nationality"]),
    new TrackInfo("gender", ["personal-data", "gender"]),

    new TrackInfo(
      "marital-status",
      ["marital-status", "marital-status"],
      undefined,
      {
        undefined,
        actionName: ActionList.ActionMarital,
      }
    ),
    new TrackInfo("spouse", ["marital-status", "spouse"]),

    new TrackInfo("cep", ["address", "cep"]),
    new TrackInfo("address-name", ["address", "name"]),
    new TrackInfo("address-number", ["address", "number"]),
    new TrackInfo("address-adjunt", ["address", "adjunt"]),
    new TrackInfo("district", ["address", "district"]),
    new TrackInfo("address-state", ["address", "state"]),
    new TrackInfo("address-city", ["address", "city"]),

    new TrackInfo(
      "origin-income",
      ["professional-data", "origin-income"],
      undefined,
      {
        undefined,
        actionName: ActionList.ActionOrigin,
      }
    ),
    new TrackInfo(
      "profession",
      ["professional-data", "profession"],
      undefined,
      {
        undefined,
        actionName: ActionList.ActionIncome,
      }
    ),
    new TrackInfo("company-cnpj", ["professional-data", "company-cnpj"]),

    ...trackDefaultIncomeBasic,
  ];

  track = [];
  public registratioJourney: any;

  constructor(private cacheNativeService: CacheService) {
    super();
    this.setBasicTrack();
  }

  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC;
  }

  async loadData() {
    // MobileMockData.executeMockCall(500);
    let data = await this.cacheNativeService.getItemCommunicator();
    data = ContaIonDataParse.parseFromMobileData(data);
    localStorage.setItem("cache-native", JSON.stringify(data));
    return Promise.resolve(data);
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    switch (actionName) {
      case ActionList.ActionStateBR:
        return BirthCountryInvestAction.execute(data);
      case ActionList.ActionMarital:
        return MaritalStatusInvestAction.execute(data, this.track);
      case ActionList.ActionOrigin:
        return OriginInvestAction.execute(
          data,
          this.track,
          false,
          this.includeTrack.bind(this)
        );
      case ActionList.ActionIncome:
        return OriginIncomeInvestAction.execute(data, this.track);
    }
  }

  isUncoupled() {
    return false;
  }

  public async setBasicTrack() {
    const trackCI: string[] = [];
    let data = await this.cacheNativeService.getItemCommunicator();
    data = ContaIonDataParse.parseFromMobileData(data);
    this.registratioJourney = data;

    if (!this.registratioJourney.data?.personalData?.isCompleted) {
      trackCI.push("personal-data");
    }

    if (!this.registratioJourney.data?.address?.isCompleted) {
      trackCI.push("address");
    }

    if (!this.registratioJourney.data?.maritalStatus?.isCompleted) {
      trackCI.push("marital-status");
    }

    if (!this.registratioJourney.data?.professionalData?.isCompleted) {
      trackCI.push("professional-data");
    }

    if (!this.registratioJourney.data?.incomeEquity?.isCompleted) {
      trackCI.push("income");
    }

    if (trackCI.length > 0) {
      this.track = this.originalTracks.filter((trackInfo: TrackInfo) =>
        trackCI.includes(trackInfo.path[0])
      );
    } else {
      this.track = this.originalTracks;
    }
  }

  includeTrack(newtrack: TrackInfo[]) {
    this.track = [...this.track, ...newtrack];
  }

  isEventComunicator() {
    return true;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  ActionState = "actionState",
  ActionStateBR = "actionStateBR",
  ActionOrigin = "actionOrigin",
  ActionIncome = "actionIncome",
  ActionMarital = "actionMarital",
}
